<template>
  <div class="flex py-4">
    <div class="w-6/12 justify-start flex">
      <div class="table__search-input-wrapper w-[400px] opacity-75">
        <span class="pr-2 opacity-50"><search-icon /> </span>

        <input
          type="text"
          class="table__search-input"
          placeholder="Search..."
          v-model="searchString"
        />
        <img
          @click="showFilterModal = true"
          class="cursor-pointer"
          src="@/assets/images/icons/search.svg"
          alt="search icon"
        />
      </div>
    </div>
    <div class="date-picker w-6/12 flex items-center justify-end">
      <div v-if="filterType == 'custom'" class="flex justify-end w-full px-4 pt-0">
        <div class="date-picker flex items-center justify-center">
          <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />
          <span class="pr-2 opacity-50"> to </span>
          <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
        </div>
      </div>
      <!-- <div> -->
        <div>
          <el-dropdown trigger="click" class="h-full w_semi">
            <div class="drp-content">
              <span>
                <img src="../icons/CalendarIcon.svg" />
                <abbr class="vrt_line"></abbr>
                <span class="inline-block whitespace-nowrap">{{ filterTitle }}</span>
              </span>
              <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click="filterType = 'MTD'">
                <button @click="setFilterType('today', 'Today')">Today</button>
              </el-dropdown-item>

              <el-dropdown-item >
                <button @click="setFilterType('week', 'This week')">This week</button>
              </el-dropdown-item>

              <el-dropdown-item>
                <button @click="setFilterType('month', 'This month')">This month</button>
              </el-dropdown-item>

              <el-dropdown-item>
                <button @click="setFilterType('year', 'This year')">This year</button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button @click="setFilterType('all', 'All time')">All time</button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button @click="setFilterType('custom', 'Custom')">Custom</button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- <el-dropdown trigger="click" class="h-full w_semi">
          <div class="drp-content">
            <span>
              <img src="../icons/CalendarIcon.svg" />
              <abbr class="vrt_line"></abbr>
              This month
            </span>
            <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click="filterType = 'today'">>
              <button>MTD</button>
            </el-dropdown-item>

            <el-dropdown-item >
              <button @click="filterType = 'YTD'">YTD</button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button @click="filterType = 'WTD'">WTD</button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button @click="filterType = 'All'">All Time</button>
            </el-dropdown-item>
            <el-dropdown-item>
              <button>Custom</button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      <!-- </div> -->

      <button class="refrsh_btn" @click="resetDate">
        <img src="../icons/RefreshIcon.svg"/>
      </button>
    </div>
    <filter-table
      :show-modal="showFilterModal"
      :activeTab="activeTab"
      @getStatusProps="getStatusProps"
      @close-modal="showFilterModal = false"
    />
  </div>
</template>

<script>
import FilterTable from "../modals/FilterTable.vue";
import ArrowDownBlackIcon from "@/components/UI/svgs/ArrowDownBlackIcon.vue";

export default {
  props:{
    activeTab:{
      type: String
    }
  },
  components: {
    FilterTable,
    ArrowDownBlackIcon
  },
  methods: {
    getStatusProps(val){
        this.statusFilter =  val
      },
    resetDate(){
      this.filterType = 'month'
      this.filterTitle = 'This Month'
    },
    setFilterType(val, title){
      this.filterType = val
      this.filterTitle = title
    }
  },
  computed: {
    sortProps() {
      return {
        startDate: this.filterType == 'custom' ? this.startDate : undefined,
        endDate:  this.filterType == 'custom' ? this.endDate : undefined,
        searchString: this.searchString,
        interval: this.filterType,
        statusFilter: this.statusFilter
      };
    },
  },
  watch: {
    sortProps(val) {  
      if(this.startDate < this.endDate || this.statusFilter){
        this.$emit("setQueryparams", val);
      }
      else if(!this.startDate && !this.endDate){
        this.$emit("setQueryparams", val);
      }
    },
  },
  // setQueryparams
  data() {
    return {
      filterTitle: "This Month",
      showFilterModal: false,
      startDate: "",
      endDate: "",
      searchString: "",
      filterType: 'month',
      statusFilter: undefined,
    };
  },
};
</script>

<style lang="scss" scoped>
.w_semi {
  @apply w-[200px] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}
.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}
.refrsh_btn{
  @apply px-4 py-3 bg-white shadow-lg rounded-md ml-2
}
</style>
